// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-rLW","col":"styles_col__1U2KI"};